import './glowingtext.css'

export const GlowingText2em = ({ content }) => (
    <div className='glowingtext2em'>
        <p>
            <span>{content}</span>
        </p>
    </div>
);
